import React from 'react';
import { GiAirplaneArrival, GiAirplaneDeparture, GiHouse } from 'react-icons/gi';
import { useParams } from 'react-router-dom';
import Detail from '../components/pages/detail';
import DetailComponent from '../components/details/flight_schedule';
export default () => {
    const {direction, id} = useParams();
    
    const Icon=direction==='arrival'?GiAirplaneArrival:GiAirplaneDeparture;
    return (
        <Detail 
            title={`flight_schedule_${direction}`} 
            icon={Icon} 
            id={id}
            url={`api/v1/flight_schedule/international/${direction}/detail`}
            getBreadcumbValue={({flight_number})=>flight_number}
            breadcrumbs={
                [
                    {
                        href:'/home',
                        icon:<GiHouse color='white' />,
                        item:'home'
                    },
                    {
                        item:'flight_schedule'
                    },
                    {
                        item:'flight_schedule_'+direction,
                        href:'/flight/schedule/'+direction
                    }
                ]
            }
            DetailComponent={DetailComponent}
            additionalData={{direction, id}}
        />
    )
}